export enum SortDirection {
    /** 0 */
    UNKNOWN_SORT_DIRECTION = 'UNKNOWN_SORT_DIRECTION',
    /** 1 */
    ASCENDING = 'ASCENDING',
    /** 2 */
    DESCENDING = 'DESCENDING'
}
